class DataLayerService {

  //Calculate the values
  productRevenueDetails(selectProduct, quote, serviceType){
    let metric3 = 0
    let metric4 = 0
    let revenue = 0
    let products = []

    let productPackage = {
      'id': undefined,
      'name': undefined,
      'price': undefined,
      'quantity': 1,
      'metric1': undefined,
      'metric2': undefined,
      'category': undefined,
      'variant': undefined,
      'dimension1': undefined,
      'dimension2': undefined
    };

    //for cordell estimator
    if(serviceType !== null && serviceType === 'CordellEstimatorNZ'){
      let estimatorAddonsDetails = [
        {
          'name': 'Planswift',
          'price': 219.54
        }
      ];
      selectProduct = selectProduct.configuration;
      productPackage.name = 'Estimator Platinum';
      productPackage.item_brand = 'Cordell Estimator';
      if (selectProduct.packageName === 'cordell_estimator_platinum_lite') {
        productPackage.variant = 'Estimator Lite';
        productPackage.id = 'CEPL';
      }
      let estimatorAddonsPrice = 0;
      if (selectProduct.addons && selectProduct.addons.length > 0) {
        for (
          let estimatorAddonIndex = 0;
          estimatorAddonIndex < selectProduct.addons.length;
          estimatorAddonIndex++
        ) {
          let adEstimator = selectProduct.addons[estimatorAddonIndex];
          for (let iIndex = 0; iIndex < estimatorAddonsDetails.length; iIndex++) {
            let adnitem = estimatorAddonsDetails[iIndex];
            if (adEstimator === adnitem.name) {
              estimatorAddonsPrice = estimatorAddonsPrice + adnitem.price;
            }
          }
        }
        if (estimatorAddonsPrice > 0) {
          productPackage.metric1 = parseFloat(
            ((quote.totalPerMonth - estimatorAddonsPrice) / 1.1).toFixed(2)
          );
          productPackage.metric2 = parseFloat(
            (((quote.totalPerMonth - estimatorAddonsPrice) / 1.1) * 12).toFixed(2)
          );
        }
      } else {
        productPackage.metric1 = parseFloat((quote.totalPerMonth / 1.1).toFixed(2));
        productPackage.metric2 = parseFloat(((quote.totalPerMonth / 1.1) * 12).toFixed(2));
      }

      productPackage.price = parseFloat(
        (((quote.totalPerMonth - estimatorAddonsPrice) / 1.1) * 48).toFixed(2)
      );

      productPackage.dimension1 = selectProduct.numberOfUsers.toString();
      productPackage.dimension2 = '0'

      revenue = revenue + productPackage.price;
      metric3 = metric3 + productPackage.metric1;
      metric4 = metric4 + productPackage.metric2;
      products.push(productPackage);

      if (selectProduct.addons && selectProduct.addons.length > 0) {
        for (
          let estimatorAddonIndx = 0;
          estimatorAddonIndx < selectProduct.addons.length;
          estimatorAddonIndx++
        ) {
          let selectedAd = selectProduct.addons[estimatorAddonIndx];
          productPackage = {
            'name': selectedAd,
            'id': undefined,
            'price': undefined,
            'category': undefined,
            'quantity': 1,
            'metric1': undefined,
            'metric2': undefined
          };

          if (selectedAd === 'Planswift') {
            productPackage.id = 'Addon-Planswift';
          }

          let adItems = estimatorAddonsDetails;
          for (let adItemIndex = 0; adItemIndex < adItems.length; adItemIndex++) {
            let adItem = adItems[adItemIndex];
            if (selectedAd === adItem.name) {
              productPackage.metric1 = parseFloat((adItem.price / 1.1).toFixed(2));
              productPackage.metric2 = parseFloat(((adItem.price / 1.1) * 12).toFixed(2));
            }
          }
          productPackage.price = parseFloat((productPackage.metric1 * 48).toFixed(2));

          products.push(productPackage);
        }
      }
    }
    //Guru
    else if(serviceType !== null && serviceType === 'Guru'){
      selectProduct = selectProduct.configuration
      productPackage.item_brand = productPackage.id = productPackage.name = "Guru"
      productPackage.price = quote.totalPerMonth
      productPackage.metric1 = parseFloat((quote.totalPerMonth/1.1).toFixed(2))
      productPackage.metric2 = parseFloat(((quote.totalPerMonth/1.1) * 12).toFixed(2))
      productPackage.dimension1 = selectProduct.number_of_users.toString()
      productPackage.dimension2 = '0'
      productPackage.name = 'Guru';
      productPackage.id = 'GURU';
      if (selectProduct.package === 'lite') {
        productPackage.variant = 'Lite';
      } else if (selectProduct.package === 'base') {
        productPackage.variant = 'Base';
      } else if (selectProduct.package === 'premium') {
        productPackage.variant = 'Premium';
      } else if (selectProduct.package === 'pro') {
        productPackage.variant = 'Pro';
      }
      metric3 = metric3 + productPackage.metric1
      metric4 = metric4 + productPackage.metric2
      revenue = revenue + productPackage.price
      products.push(productPackage);
    }

    //RPNZ
    else if(serviceType !== null && serviceType === 'RPNZ'){
      selectProduct = selectProduct.configuration
      productPackage.item_brand = productPackage.id = productPackage.name = "RPNZ"
      productPackage.price = quote.totalPerMonth
      productPackage.dimension1 = selectProduct.number_of_users.toString()
      productPackage.dimension2 = '0'
      productPackage.variant = "RPNZ"

      revenue = revenue + productPackage.price
      products.push(productPackage);
    }

    let productValues = {
      'products': products,
      'revenue': revenue,
    }

    return productValues;
  }

  // Script 1
  notifyOnNewCartItem(item, configuration){
    item.quote.quotes.map(function(subItem, subIndex){
      if(subItem.productId === configuration.product_id){
        let productDetails = this.productRevenueDetails(configuration, subItem, subItem.type)
        window.dataLayer && window.dataLayer.push({
          'event': 'addToCart',
          'ecommerce': {
            'add': {
              'products': productDetails.products
            }
          }
        });
      }
    }.bind(this))

  }

  // Script 2
  notifyOnDeleteCartItem(item){
    if(item !== undefined) {
      let productDetails = this.productRevenueDetails(item.configuration, item, item.type)
      for(let index=0;index<productDetails.products.length;index++){
        let product = productDetails.products[index]
        window.dataLayer && window.dataLayer.push({
          'event': 'removeFromCart',
          'ecommerce': {
            'remove': {
              'products': [{
                'name': product.name,
                'id': product.id,
                'price':  product.price,
                'category': product.category,
                'variant': product.variant,
                'quantity': product.quantity,
                'dimension1': product.dimension1,
                'dimension2': product.dimension2
              }]
            }
          }
        });
      }
    }
  }

  //Script 3
  notifyOnCheckout(data){
    if(data.order && data.order.quotes && data.order.quotes.quotes && data.order.quotes.quotes.length > 0){
      let serviceType = undefined
      let productDetails = {}
      let products = []

      data.order.quotes.quotes.map(function(quote, index){
        data.order.quoteConfiguration.products.map(function(quoteConfig, quoteConfigIndex){
          if(quoteConfig.product_id === quote.productId){

            serviceType = quote.type
            productDetails = this.productRevenueDetails(quoteConfig, quote, serviceType)
            for(let subIndex=0;subIndex<productDetails.products.length;subIndex++){
              let product = productDetails.products[subIndex]
              products.push(product);
            }

          }
        }.bind(this))
      }.bind(this))

      window.dataLayer && window.dataLayer.push({
        'event': 'checkout',
        'ecommerce': {
          'checkout': {
            'actionField': {'step': 1},
            'products': products
          }
        }
      });
    }
  }

  //Script 4
  setCheckoutOptionDataLayer(option){
    window.dataLayer && window.dataLayer.push({
      'event': 'checkoutOption',
      'ecommerce': {
        'checkout': {
          'actionField': {'step': 1, 'option': option }
        }
      }
    })
  }

  //Script 5
  setDataLayer(data){
    let serviceType = undefined
    let coupon = null
    let productDetails = {}
    let products = []
    let revenue = 0

    if(!data.order || !data.order.quotes) {
      return;
    }

    if(data.order.quotes.coupon !== null) {
      coupon = data.order.quotes.coupon && data.order.quotes.coupon.code
    }

    data.order.quotes.quotes && data.order.quotes.quotes.map(function(quote, index){
      data.order.quoteConfiguration.products.map(function(quoteConfig, quoteConfigIndex){
        if(quoteConfig.product_id === quote.productId){

          serviceType = quote.type
          productDetails = this.productRevenueDetails(quoteConfig, quote, serviceType)
          for(let subIndex=0;subIndex<productDetails.products.length;subIndex++){
            let product = productDetails.products[subIndex]
            if(data.order?.customer?.industry) {
              product.category = data.order.customer.industry;
            }
            product.coupon = coupon
            delete product['metric1']
            delete product['metric2']
            products.push(product);
          }
          revenue = revenue + productDetails.revenue*12
        }
      }.bind(this))
    }.bind(this))
    const tax = (revenue / 1.1) * 0.1;
    const event_revenue = Number(Math.abs(revenue).toFixed(2));
    const event_tax = Number(Math.abs(tax).toFixed(2));
    const transaction_id = data.order.orderNumber.toString();

    const purchaseEvent = {
      "event": "purchase",
      "ecommerce": {
        "currency": "NZD",
        "items": products,
        "transaction_id": transaction_id,
        "affiliation": "Corestore NZ",
        "value": event_revenue,
        "tax": event_tax,
        "coupon": coupon,
        "shipping": 0.00
      }
    };

    if (revenue > 0) {
      try {
        window.dataLayer && window.dataLayer.push({ ecommerce: null });
        window.dataLayer && window.dataLayer.push(purchaseEvent);
      } catch (error) {
          console.error("An error occurred: ", error);
      }
    }
  }
}

export default DataLayerService;

